import {Icon, Badge, view, Tooltip} from '@sail/ui';
import {check, cancel, clock, warningCircle} from '@sail/icons/react/Icon';
import {defineMessages, useIntl} from 'react-intl';

type PaymentIntentCardStatusBadgeProps = {
  status: string;
};

const messages = defineMessages({
  succeeded: {
    id: 'conversations_ui.payment_intent_card_status_badge.succeeded',
    description: 'Succeeded status',
    defaultMessage: 'Succeeded',
  },
  processing: {
    id: 'conversations_ui.payment_intent_card_status_badge.processing',
    description: 'Processing status',
    defaultMessage: 'Processing',
  },
  requires_action: {
    id: 'conversations_ui.payment_intent_card_status_badge.requires_action',
    description: 'Requires action status',
    defaultMessage: 'Requires action',
  },
  requires_capture: {
    id: 'conversations_ui.payment_intent_card_status_badge.requires_capture',
    description: 'Requires capture status',
    defaultMessage: 'Requires capture',
  },
  requires_confirmation: {
    id: 'conversations_ui.payment_intent_card_status_badge.requires_confirmation',
    description: 'Requires confirmation status',
    defaultMessage: 'Requires confirmation',
  },
  requires_payment_method: {
    id: 'conversations_ui.payment_intent_card_status_badge.requires_payment_method',
    description: 'Requires payment method status',
    defaultMessage: 'Requires payment method',
  },
  canceled: {
    id: 'conversations_ui.payment_intent_card_status_badge.canceled',
    description: 'Canceled status',
    defaultMessage: 'Canceled',
  },
});

export const PaymentIntentCardStatusBadge = ({
  status,
}: PaymentIntentCardStatusBadgeProps) => {
  const intl = useIntl();

  let icon;
  let type: 'positive' | 'neutral';
  let statusText;

  switch (status) {
    case 'succeeded':
      icon = check;
      type = 'positive';
      statusText = intl.formatMessage(messages.succeeded);
      break;
    case 'processing':
      icon = clock;
      type = 'neutral';
      statusText = intl.formatMessage(messages.processing);
      break;
    case 'canceled':
      icon = cancel;
      type = 'neutral';
      statusText = intl.formatMessage(messages.canceled);
      break;
    case 'requires_action':
      icon = warningCircle;
      type = 'neutral';
      statusText = intl.formatMessage(messages.requires_action);
      break;
    case 'requires_capture':
      icon = warningCircle;
      type = 'neutral';
      statusText = intl.formatMessage(messages.requires_capture);
      break;
    case 'requires_confirmation':
      icon = warningCircle;
      type = 'neutral';
      statusText = intl.formatMessage(messages.requires_confirmation);
      break;
    case 'requires_payment_method':
      icon = warningCircle;
      type = 'neutral';
      statusText = intl.formatMessage(messages.requires_payment_method);
      break;
    default:
      return null;
  }

  if (icon && type && statusText) {
    return (
      <view.div
        css={{
          display: 'flex',
          width: '100%',
        }}
      >
        <Tooltip
          trigger={
            <Badge
              type={type}
              css={{
                maxWidth: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <view.span
                css={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  minWidth: 0,
                }}
              >
                {statusText}
              </view.span>
              <view.span
                css={{
                  marginLeft: 'xxsmall',
                  display: 'flex',
                  flexShrink: 0,
                }}
              >
                <Icon icon={icon} size="xsmall" />
              </view.span>
            </Badge>
          }
        >
          {statusText}
        </Tooltip>
      </view.div>
    );
  }
};
